import { lazy } from "react";
import ViewStudentNotification from "@repo/design-system/components/viewStudentNotification/ViewStudentNotification.jsx";

/** Pages */
const Profile = lazy(() => import("../pages/profile/Profile"));
const Settings = lazy(() => import("../pages/settings/Settings"));
const EditProfile = lazy(() => import("../pages/editProfile/EditProfile"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));

const ViewStudentNotificationPage = () => (
    <ViewStudentNotification />
);

/** Skill Passport */
const SkillMaster = lazy(() => import("../pages/skillMaster/SkillMaster"));
const JobOrientedSkill = lazy(() => import("../pages/jobOrientedSkill/JobOrientedSkill"));
const AcademicRecords = lazy(() => import("../pages/academicRecords/AcademicRecords"));
const SkillAchievements = lazy(() => import("../pages/skillAchievements/SkillAchievements"));

// Announcements
const StudentAnnouncements = lazy(() => import("../pages/studentAnnouncements/StudentAnnouncements"));

// Student Achievements
const StudentSkillAchievements = lazy(() => import("../pages/studentSkillAchievements/StudentSkillAchievements"));

// Dev-only: visual preview of the Skill Passport PDF template (see the file for how to use it)
const SkillPassportDocumentPreview = lazy(() => import("../pages/skillPassportDocumentPreview/SkillPassportDocumentPreview"));

// const SkillManagement = lazy(() => import("../pages/skillManagement/SkillManagement"));

const ComponentNavigation = [

    /** Platform -  Dashboard */
    {
        id: "dashboard", path: "/dashboard", exact: true, title: "",
        component: Dashboard, hasParams: false, text: "Dashboard Page"
    },
    /** Skill Management */
    // {
    //     id: "skillManagement", path: "/skillManagement", exact: true, title: "",
    //     component: SkillManagement, hasParams: false, text: "Skill Management"
    // },
    {
        id: "skillAchievements", path: "/skill-achievements", exact: true, title: "",
        component: SkillAchievements, hasParams: false, text: "Skill Achievements"
    },
    {
        id: "skillMaster", path: "/skill-master", exact: true, title: "",
        component: SkillMaster, hasParams: false, text: "Skill Master"
    },
    {
        id: "jobOrientedSkill", path: "/job-oriented-skill", exact: true, title: "",
        component: JobOrientedSkill, hasParams: false, text: "Job-Oriented Skill Master"
    },
    {
        id: "academicRecords", path: "/academic-records", exact: true, title: "",
        component: AcademicRecords, hasParams: false, text: "Academic Records"
    },
    {
        id: "profile", path: "/profile", exact: true, title: "",
        component: Profile, hasParams: false, text: "My Profile"
    },
    {
        id: "edit-profile", path: "/edit-profile", exact: true, title: "",
        component: EditProfile, hasParams: false, text: "Edit Profile",
    },
    {
        id: "settings", path: "/settings", exact: true, title: "",
        component: Settings, hasParams: false, text: "Settings"
    },
    {
        id: "viewStudentNotification", path: "/view-student-notification", exact: true, title: "",
        component: ViewStudentNotificationPage, hasParams: false, text: "View Student Notifications"
    },
    {
        id: "studentAnnouncements", path: "/student-announcements", exact: true, title: "",
        component: StudentAnnouncements, hasParams: false, text: "Student Announcements"
    },
    {
        id: "studentSkillAchievements", path: "/student-achievements", exact: true, title: "",
        component: StudentSkillAchievements, hasParams: false, text: "Student Skill Achievements"
    },
    {
        id: "skillPassportDocumentPreview", path: "/skill-passport-preview", exact: true, title: "",
        component: SkillPassportDocumentPreview, hasParams: false, text: "Skill Passport Document Preview"
    }
];

export default ComponentNavigation;
